export default __webpack_public_path__ + "35ed9d77cfff8a01dbb4d35b672d46fb.svg";